import { render, staticRenderFns } from "./EnforcementDebtList.vue?vue&type=template&id=1ba6ff2f"
import script from "./EnforcementDebtList.vue?vue&type=script&lang=js"
export * from "./EnforcementDebtList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports